import { useEffect } from "react";
import Topbar from "./topBar";
import Sidebar from "./sideBar";
import Content from "./content";

const Dashboard = () => {
  useEffect(() => {
    return () => {};
  }, []);

  return (
    <div id="wrapper">
      <Topbar backgroundColor="#0baae5" />

      <Sidebar />

      <Content />
    </div>
  );
};

export default Dashboard;
